import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import GravitySeparatorSettlingChamber from 'features/processFlowDiagrams/svg/separators/gravity-separator-settling-chamber.svg?react'
import ImpactSeparator from 'features/processFlowDiagrams/svg/separators/impact-separator.svg?react'
import SeparatorCyclone from 'features/processFlowDiagrams/svg/separators/separator-cyclone.svg?react'
import SeparatorElectromagnetic from 'features/processFlowDiagrams/svg/separators/separator-electromagnetic.svg?react'
import SeparatorElectrostaticPrecipitator from 'features/processFlowDiagrams/svg/separators/separator-electrostatic-precipitator.svg?react'
import SeparatorElectrostaticPrecipitatorWet from 'features/processFlowDiagrams/svg/separators/separator-electrostatic-precipitator-wet.svg?react'
import SeparatorPermanentMagnet from 'features/processFlowDiagrams/svg/separators/separator-permanent-magnet.svg?react'
import SeparatorSifter from 'features/processFlowDiagrams/svg/separators/separator-sifter.svg?react'
import SeparatorVenturiScrubber from 'features/processFlowDiagrams/svg/separators/separator-venturi-scrubber.svg?react'
import SeparatorWetScrubber from 'features/processFlowDiagrams/svg/separators/separator-wet-scrubber.svg?react'
import SolidifierClosed from 'features/processFlowDiagrams/svg/separators/solidifier-closed.svg?react'
import SolidifierOpen from 'features/processFlowDiagrams/svg/separators/solidifier-open.svg?react'
import SprayScrubber from 'features/processFlowDiagrams/svg/separators/spray-scrubber.svg?react'
import React from 'react'

export const PID_SEPARATORS_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'gravity-separator-settling-chamber',
    name: 'Gravity Separator, Settling Chamber',
    category: 'separators',
    svgContent: <GravitySeparatorSettlingChamber />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'impact-separator',
    name: 'Impact Separator',
    category: 'separators',
    svgContent: <ImpactSeparator />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-sifter',
    name: 'Separator, Sifter',
    category: 'separators',
    svgContent: <SeparatorSifter />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-cyclone',
    name: 'Separator (Cyclone)',
    category: 'separators',
    svgContent: <SeparatorCyclone />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-electromagnetic',
    name: 'Separator (Electromagnetic)',
    category: 'separators',
    svgContent: <SeparatorElectromagnetic />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-electrostatic-precipitator',
    name: 'Separator (Electrostatic Precipitator)',
    category: 'separators',
    svgContent: <SeparatorElectrostaticPrecipitator />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-electrostatic-precipitator-wet',
    name: 'Separator (Electrostatic Precipitator, Wet)',
    category: 'separators',
    svgContent: <SeparatorElectrostaticPrecipitatorWet />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-permanent-magnet',
    name: 'Separator (Permanent Magnet)',
    category: 'separators',
    svgContent: <SeparatorPermanentMagnet />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-venturi-scrubber',
    name: 'Separator (Venturi Scrubber)',
    category: 'separators',
    svgContent: <SeparatorVenturiScrubber />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'separator-wet-scrubber',
    name: 'Separator (Wet Scrubber)',
    category: 'separators',
    svgContent: <SeparatorWetScrubber />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'solidifier-closed',
    name: 'Solidifier (Closed)',
    category: 'separators',
    svgContent: <SolidifierClosed />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'solidifier-open',
    name: 'Solidifier (Open)',
    category: 'separators',
    svgContent: <SolidifierOpen />,
    viewBox: '0 0 80 120',
  },
  {
    id: 'spray-scrubber',
    name: 'Spray Scrubber',
    category: 'separators',
    svgContent: <SprayScrubber />,
    viewBox: '0 0 80 120',
  },
]
